import { useQuery } from 'react-query';
import { BookingsApi } from 'swagger/apis/bookings-api';
import OpenApiConfiguration from 'api/OpenApiConfiguration';

const bookingsApi = new BookingsApi(OpenApiConfiguration);

export const useGetBookingActionsDataQuery = (bookingId) =>
  useQuery(['bookingActions', bookingId], () => bookingsApi.domesticV3BookingsIdActionsGet(bookingId), {
    refetchOnWindowFocus: false,
  });

export const useGetBookingActions = (bookingId) => {
  const { data: { data: bookingActions } = {}, ...other } = useGetBookingActionsDataQuery(bookingId);

  return {
    ...bookingActions,
    ...other,
  };
};
